"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConfirmDialogName = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _basisDialog = _interopRequireDefault(require("./basis-dialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ConfirmDialogName = 'confirmDialog';
exports.ConfirmDialogName = ConfirmDialogName;

var ConfirmDialog = function ConfirmDialog(_ref) {
  var active = _ref.active,
      onCloseDialog = _ref.onCloseDialog,
      className = _ref.className,
      content = _ref.content,
      title = _ref.title,
      confirmText = _ref.confirmText,
      cancelText = _ref.cancelText;
  var actions = [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    key: "cancelAction",
    primary: true,
    className: "action-button cancel-button",
    onClick: function onClick() {
      return onCloseDialog(false);
    }
  }, cancelText), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    key: "confirmAction",
    raised: true,
    primary: true,
    className: "action-button confirm-button",
    onClick: function onClick() {
      return onCloseDialog(true);
    }
  }, confirmText)];
  return /*#__PURE__*/_react["default"].createElement(_basisDialog["default"], {
    active: active,
    className: "confirm-dialog ".concat(className),
    onCloseDialog: onCloseDialog,
    content: content,
    title: title,
    actions: actions
  });
};

ConfirmDialog.propTypes = {
  className: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  onCloseDialog: _propTypes["default"].func,
  content: _propTypes["default"].node,
  title: _propTypes["default"].node,
  confirmText: _propTypes["default"].node,
  cancelText: _propTypes["default"].node
};

var noop = function noop() {};

ConfirmDialog.defaultProps = {
  className: '',
  active: false,
  onCloseDialog: noop,
  content: null,
  title: '',
  confirmText: '',
  cancelText: ''
};
var _default = ConfirmDialog;
exports["default"] = _default;